import { render, staticRenderFns } from "./AssetsView.vue?vue&type=template&id=1d4fbad2"
import script from "./AssetsView.vue?vue&type=script&lang=js"
export * from "./AssetsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports